var map = {
	"./dropbox.svg": "1427",
	"./ediscovery_project_export.svg": "aa64",
	"./export_to_dropbox.svg": "9d24",
	"./o365_email.svg": "548a",
	"./o365_group.svg": "c4c0",
	"./o365_onedrive.svg": "3dfd8",
	"./o365_sharepoint.svg": "0c63",
	"./o365_sso.svg": "ae8b",
	"./o365_teams.svg": "4748"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56db";